// extracted by mini-css-extract-plugin
export default {"widget":"DashboardWidget_widget__dtIyQ","loading":"DashboardWidget_loading__h-QYB","widgetless":"DashboardWidget_widgetless__eoHto"};